import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Import\GetImportTaskController::__invoke
* @see app/Http/Controllers/Import/GetImportTaskController.php
* @route '/api/import/{import}/task/{importTask}'
*/
const GetImportTaskController = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetImportTaskController.url(args, options),
    method: 'get',
})

GetImportTaskController.definition = {
    methods: ["get","head"],
    url: '/api/import/{import}/task/{importTask}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Import\GetImportTaskController::__invoke
* @see app/Http/Controllers/Import/GetImportTaskController.php
* @route '/api/import/{import}/task/{importTask}'
*/
GetImportTaskController.url = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            import: args[0],
            importTask: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        import: args.import,
        importTask: typeof args.importTask === 'object'
        ? args.importTask.id
        : args.importTask,
    }

    return GetImportTaskController.definition.url
            .replace('{import}', parsedArgs.import.toString())
            .replace('{importTask}', parsedArgs.importTask.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Import\GetImportTaskController::__invoke
* @see app/Http/Controllers/Import/GetImportTaskController.php
* @route '/api/import/{import}/task/{importTask}'
*/
GetImportTaskController.get = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetImportTaskController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Import\GetImportTaskController::__invoke
* @see app/Http/Controllers/Import/GetImportTaskController.php
* @route '/api/import/{import}/task/{importTask}'
*/
GetImportTaskController.head = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetImportTaskController.url(args, options),
    method: 'head',
})

export default GetImportTaskController